"use client";

import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import type { MeetingFormValues } from "../../types/meeting-form";

interface MeetingTitleProps {
  control: Control<MeetingFormValues>;
  isSubmitting: boolean;
}

export const MeetingTitle: React.FC<MeetingTitleProps> = ({ control, isSubmitting }) => {
  return (
    <FormField
      control={control}
      name="title"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Meeting Title</FormLabel>
          <FormControl>
            <Input
              placeholder="What is this meeting about?"
              {...field}
              disabled={isSubmitting}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
